module.exports = __webpack_public_path__ + "static/media/IMG_2079-minJPG.498ffa5f.jpg";